<div class="px-3 py-2">
	<h4 align="center">EVENTO CONOSCITIVO DELL'INIZIATIVA DE COMPONENDIS CIFRIS</h4>
	<p>Il 22 gennaio 2018 si è tenuto il primo incontro conoscitivo della 
		costituenda associazione nazionale di crittografia De Componendis Cifris.
		L'evento era riservato agli iscritti e si è tenuto presso quattro sedi in 
		video-conferenza:
	</p>
	<ul>
		<li><p>Torino, Università di Torino, via Carlo Alberto 10, Sala Orsi;</p></li>
		<li><p>Roma, Università di Roma3, Largo S. Leon. Murialdo 1, Sala Riunioni attrezzata di Matematica;</p></li>
		<li><p>Bologna, Dipartimento di Matematica, Piazza di Porta S. Donato 5, Aula Seminario II;</p></li>
		<li><p>Napoli, CNR Area della Ricerca NA1, via Pietro Castellino 111, Sala Riunioni Icar 207.</p></li>
	</ul>
	<p><a href="../../../../assets/eventi/2018/EventoConoscitivo/Locandina_Evento_DeCifris_22.01.2018.pdf">Locandina</a></p>
	<h5>PROGRAMMA</h5>
	<ul>
		<li>
			<p><b>Presentazione evento</b></p>
			<ul class="ulSon">
				<li>
					<p>
						09:40 - 09:50 Prof. Massimiliano Sala <br>
						Acting Director De Cifris, UNITN (da Napoli)
					</p>
				</li>
				<li>
					<p>
						09:50 - 10:00 Prof. M. Elia <br>
						Acting President De Cifris, POLITO (da Torino)
					</p>
				</li>
			</ul>
		</li>
		<li>
			<p><b>10:00 - 11:00  Torino</b><br>
				(a cura dei proff. N. Murru, UNITO - A. Visconti, UNIMI)</p>
			<ul class="ulSon">
				<li>
					<p>
						10:00 - 10.15 Prof. Andrea Visconti, Dott. N. Murru<br>
						UNITO <br>
						<a href="../../../../assets/eventi/2018/EventoConoscitivo/20180122_DeCifris_N_Murru.pdf">Evento conoscitivo De Cifris 22 Gennaio 2018</a>
					</p>
				</li>
				<li>
					<p>
						10:15 - 10:30 Dott. G. Morgari<br>
						TELSY SPA <br>
						<a href="../../../../assets/eventi/2018/EventoConoscitivo/20180122_DeCifris_Telsy.pdf">Information Security</a>
					</p>
				</li>
				<li>
					<p>
						10:30 - 10:45 Dott. N. Mainardi<br>
						POLIMI <br>
						<a href="../../../../assets/eventi/2018/EventoConoscitivo/20180122_DeCifris_N_Mainardi.pdf">Cryptography & 
							Hardware Security research at Politecnico di Milano</a>
					</p>
				</li>
				<li>
					<p>
						10:45 - 11:00 Prof. A. Visconti <br>
						UNIMI <br>
						<a href="../../../../assets/eventi/2018/EventoConoscitivo/20180122_DeCifris_A_Visconti.pdf">Descrizione 
							Attività di Ricerca: Secondo Evento De Cifris – 22 Gennaio 2018</a>
					</p>
				</li>
			</ul>
		</li>
		<li>
			<p><b>14:00 - 15:00  Bologna</b> <br>
				(a cura dei proff. D.Aliffi, UNIBO - M. Baldi, UNIVPM)</p>
			<ul class="ulSon">
				<li>
					<p>
						14:00 - 14:15 Dott. D. Taufer<br>
						UNITN <br>
						<a href="../../../../assets/eventi/2018/EventoConoscitivo/20180122_DeCifris_D_Taufer.pdf">CryptoLabTN: 
							Presentazione ricerca e attività</a>
					</p>
				</li>
				<li>
					<p>
						14:15 - 14:30 Prof. V. Vespri<br>
						UNIFI <br>
						<a href="../../../../assets/eventi/2018/EventoConoscitivo/20180122_DeCifris_V_Vespri.pdf">La mia esperienza con le blockchains</a>
					</p>
				</li>
				<li>
					<p>
						14:30 - 14:45 Dott. N. Laurenti<br>
						UNIPD <br>
						<a href="../../../../assets/eventi/2018/EventoConoscitivo/20180122_DeCifris_N_Laurenti.pdf">Attività 
							scientifica e didattica negli ambiti affini alla crittografia</a>
					</p>
				</li>
				<li>
					<p>
						14:45 - 15:00 Prof. M. Baldi e Dott. P. Santini<br>
						UNIVPM <br>
						<a href="../../../../assets/eventi/2018/EventoConoscitivo/20180122_DeCifris_M_Baldi.pdf">Gruppo codici 
							e crittografia Università Politecnica delle Marche</a>
					</p>
				</li>
			</ul>
		</li>
		<li>
			<p><b>11:00 - 12:30   Roma </b><br>
				(a cura dei proff. C. Scoppola, UNIVAQ - M. Giulietti, UNIPG)</p>
			<ul class="ulSon">
				<li>
					<p>
						11:00 - 11:15 Prof. N. Gavioli<br>
						UNIVAQ <br>
						<a href="../../../../assets/eventi/2018/EventoConoscitivo/20180122_DeCifris_N_Gavioli.pdf">DeCifris&#64;univaq</a>
					</p>
				</li>
				<li>
					<p>
						11:15 - 11:30 Prof. M. Pedicini <br>
						UNIROMA3 <br>
						<a href="../../../../assets/eventi/2018/EventoConoscitivo/20180122_DeCifris_M_Pedicini.pdf">Crittografia 
							al Dipartimento di Matematica e Fisica di Roma Tre</a>
					</p>
				</li>
				<li>
					<p>
						11:30 - 11:45 Prof. F. Tartarone <br>
						UNIROMA3 <br>
					</p>
				</li>
				<li>
					<p>
						11:45 -12:00 Prof. V. Talamanca <br>
						Direttore RNTA, UNIROMA3 <br>
						<a href="../../../../assets/eventi/2018/EventoConoscitivo/20180122_DeCifris_V_Talamanca.pdf">Associazione 
							Romana di Teoria dei Numeri</a>
					</p>
				</li>
				<li>
					<p>
						12:00 - 12:15 Prof. D. Venturi <br>
						UNIROMA1 <br>
						<a href="../../../../assets/eventi/2018/EventoConoscitivo/20180122_DeCifris_D_Venturi.pdf">De Componendis 
							Cifris (secondo evento conoscitivo)</a>
					</p>
				</li>
				<li>
					<p>
						12:15 - 12:30 Prof. M. Giulietti <br>
						UNIPG <br>
						<a href="../../../../assets/eventi/2018/EventoConoscitivo/20180122_DeCifris_M_Giulietti.pdf">De Cifris a Perugia</a>
					</p>
				</li>
			</ul>
		</li>
		<li>
			<p><b>15:00 - 17:00  Napoli</b><br>
				(a cura dei proff. G. Lunardon, UNINA - G. Schmid, CNR)</p>
			<ul class="ulSon">
				<li>
					<p>
						15:00 - 15:15 Prof. G. Schmid e Dott. F. Montecuollo <br>
						CNR - UNINA2 <br>
						<a href="../../../../assets/eventi/2018/EventoConoscitivo/20180122_DeCifris_G_Schmid.pdf">
							DeCifris&#64;Cnr.it -- Encryption and compression for collections of text files*</a>
					</p>
				</li>
				<li>
					<p>
						15:15 - 15:30 Prof. D. Catalano <br>
						UNICT <br>
						<a href="../../../../assets/eventi/2018/EventoConoscitivo/20180122_DeCifris_D_Catalano.pdf">CryptoGroup 
							Università di Catania</a>
					</p>
				</li>
				<li>
					<p>
						15:30 - 15:45 Prof. I. Visconti <br>
						UNISA <br>
						<a href="../../../../assets/eventi/2018/EventoConoscitivo/20180122_DeCifris_I_Visconti.pdf">slide</a>
					</p>
				</li>
				<li>
					<p>
						15:45 - 16:00 Prof. A. Tortora <br>
						UNISA <br>
						<a href="../../../../assets/eventi/2018/EventoConoscitivo/20180122_DeCifris_A_Tortora.pdf">Il Gruppo di Salerno</a>
					</p>
				</li>
				<li>
					<p>
						16:00 - 16:10 Prof. G. Korchmáros e Prof. A. Sonnino <br>
						UNIBAS <br>	
						<a href="../../../../assets/eventi/2018/EventoConoscitivo/20180122_DeCifris_G_Korchmaros.pdf">Gruppo di ricerca 
							in geometrie combinatorie</a>
					</p>
				</li>
				<li>
					<p>
						16:15 - 16:30 Prof. S. Cuomo <br>
						UNINA
					</p>
				</li>
			</ul>
		</li>
		
</ul>

</div>
  